export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function getTranslations(type) {
	const CONFIDENTIAL = [
		{
			language: {
				id: 1,
				name: "EN"
			},
			name: "Confidential",
			description: `
			<p>
			<b>Option 3 – Anonymous client</b>
			<p>Select if the client’s name and logo must remain confidential and hidden from all content and exports.</p>
			</p>
			`
		},
		{
			language: {
				id: 2,
				name: "DE"
			},
			name: "Vertraulich",
			description: `
			<p>
			<b>Option 3 – Anonymer Kunde</b>
			<p>Wählen Sie diese Option, wenn Name und Logo des Kunden vertraulich bleiben und in allen Inhalten und Exporten ausgeblendet werden sollen.</p>

			</p>
			`
		},
		{
			language: {
				id: 3,
				name: "FR"
			},
			name: "Confidentiel",
			description: `
			<p>
			<b>Option 3 – Client anonyme</b>
			<p>Cochez cette case si le nom et le logo du client doivent rester confidentiels et masqués dans tous les contenus et exportations.</p>
			</p>
			`
		},
		{
			language: {
				id: 4,
				name: "IT"
			},
			name: "Riservato",
			description: `
			<p>
			<b>Opzione 3 – Cliente anonimo</b>
			<p>Seleziona se il nome e il logo del cliente devono rimanere riservati e nascosti da tutti i contenuti e le esportazioni.</p>
			</p>
			`
		},
		{
			language: {
				id: 5,
				name: "JA"
			},
			name: "機密",
			description: `
			<p>
			<b>オプション3 – 匿名クライアント</b>
			<p>クライアント名とロゴを機密情報として、すべてのコンテンツおよびエクスポートから非表示にする必要がある場合は、このオプションを選択してください。</p>
			</p>
			`
		}
	]

	const EXTERNAL = [
		{
			language: {
				id: 1,
				name: "EN"
			},
			name: "External",
			description: `
			<p>
			<b>Option 2 – External use permitted</b>
			<p>Select if the client’s name and logo are approved for both internal and external use.</p>
			</p>
			`
		},
		{
			language: {
				id: 2,
				name: "DE"
			},
			name: "Extern",
			description: `
			<p>
			<b>Option 2 – Externe Nutzung erlaubt</b>
			<p>Wählen Sie diese Option, wenn der Name und das Logo des Kunden sowohl für die interne als auch für die externe Nutzung freigegeben sind.</p>
			</p>
			`
		},
		{
			language: {
				id: 3,
				name: "FR"
			},
			name: "Externe",
			description: `
			<p>
			<b>Option 2 – Usage externe autorisé</b>
			<p>Sélectionnez cette option si le nom et le logo du client sont autorisés pour un usage interne et externe.</p>
			</p>

			`
		},
		{
			language: {
				id: 4,
				name: "IT"
			},
			name: "Esterno",
			description: `
			<p>
			<b>Opzione 2 – Uso esterno consentito</b>
			<p>Seleziona se il nome e il logo del cliente sono approvati sia per uso interno che esterno.</p>
			</p>

			`
		},
		{
			language: {
				id: 5,
				name: "JA"
			},
			name: "外部の",
			description: `
			<p>
			<b>オプション2 – 外部使用可</b>
			<p>クライアント名とロゴを社内外両方で使用することが承認されている場合は、こちらを選択してください。</p>
			</p>
			`
		}
	]

	const INTERNAL = [
		{
			language: {
				id: 1,
				name: "EN"
			},
			name: "Internal",
			description: `
			<p>
			<b>Option 1 – Internal use only</b>
			<p>Select if the client’s name and logo may be used internally but must not be shared externally.</p>
			<i>Project page and download forms will include an internal-use disclaimer.</i>
			</p>
			`
		},
		{
			language: {
				id: 2,
				name: "DE"
			},
			name: "Intern",
			description: `
			<p>
			<b>Option 1 – Nur für den internen Gebrauch</b>
			<p>Wählen Sie diese Option, wenn der Name und das Logo des Kunden intern verwendet, aber nicht extern weitergegeben werden dürfen.</p>
			<i>Die Projektseite und die Downloadformulare enthalten einen Haftungsausschluss für den internen Gebrauch.</i>
			</p>
			`
		},
		{
			language: {
				id: 3,
				name: "FR"
			},
			name: "Interne",
			description: `
			<p>
			<b>Option 1 – Usage interne uniquement</b>
			<p>Sélectionnez si le nom et le logo du client peuvent être utilisés en interne, mais ne doivent pas être partagés en externe.</p>
			<i>La page du projet et les formulaires de téléchargement incluront une clause de non-responsabilité relative à l'usage interne.</i>
			</p>
			`
		},
		{
			language: {
				id: 4,
				name: "IT"
			},
			name: "Interno",
			description: `
			<p>
			<b>Opzione 1 – Solo per uso interno</b>
			<p>Seleziona se il nome e il logo del cliente possono essere utilizzati internamente ma non devono essere condivisi esternamente.</p>
			<i>La pagina del progetto e i moduli di download includeranno un'informativa sull'uso interno.</i>
			</p>
			`
		},
		{
			language: {
				id: 5,
				name: "JA"
			},
			name: "内部",
			description: `
			<p>
			<b>オプション1 – 社内利用のみ</b>
			<p>クライアント名とロゴを社内での使用は許可するが、社外への共有は禁止する場合に選択してください。</p>
			<i>プロジェクトページとダウンロードフォームには、社内利用に関する免責事項が含まれます。</i>
			</p>
			`
		}
	]

	const translations = {INTERNAL, EXTERNAL, CONFIDENTIAL}

	return translations[type]
}

export function getOrder(type) {
	const order = {
		"INTERNAL": 1,
		"EXTERNAL": 2,
		"CONFIDENTIAL": 3
	}

	return order[type];
}

export function mapConfidentiality(confidentiality) {
	if (confidentiality.label === "HIDDEN") {
		confidentiality.label = 'CONFIDENTIAL'
	}

	return {
		id: Number(confidentiality.id),
		name: confidentiality.label,
		filterType: confidentiality.filterType,
		translations: getTranslations(confidentiality.label),
		order: getOrder(confidentiality.label),
		description: confidentiality.description
	};
}
